import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * SPD-13: guards the OAuth consent page. Unlike the global {@link authGuard}, a signed-out user
 * is sent to login with `redirect=<this url>` (query string included), so they come back to the
 * consent page after signing in. Only this page returns to itself after login (user decision).
 */
export const oauthAuthorizeGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.ensureSessionRestored()
    .then((restored) => restored
      ? true
      : router.createUrlTree(['/auth/login'], { queryParams: { redirect: state.url } }));
};
